var PREFIX = "TARGET_CONTROL.";
// ACTION TYPES
export var SET_SELECTED_TARGET = PREFIX + "SET_SELECTED_TARGET";
export var UPDATE_ALL_TARGETS_LOCALLY = PREFIX + "UPDATE_ALL_TARGETS_LOCALLY";
export var UPDATE_TARGET_LOCALLY = PREFIX + "UPDATE_TARGET_LOCALLY";
export var UPDATE_DEFAULT_TARGET_LOCALLY = PREFIX + "UPDATE_DEFAULT_TARGET_LOCALLY";
